import PropTypes from 'prop-types';
import { useAppContext } from '../../store/AppContext';

const sampleUserPermissions = [
  'GET_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
];

export const hasPermission = ({ permissions, scopes }) => permissions.some((permission) => scopes.includes(permission));

export const isGranted = (user, scopes) => {
  if (!user || !scopes?.length) return false;
  // const { permissions } = user;
  const permissions = sampleUserPermissions; // example to remove
  const permissionGranted = permissions?.length ? hasPermission({ permissions, scopes }) : false;
  return permissionGranted;
};

export default function PermissionsGate({
  children,
  scopes = [],
}) {
  const [{ user }] = useAppContext();

  if (!isGranted(user, scopes)) return null;
  return children;
}

PermissionsGate.propTypes = {
  children: PropTypes.node.isRequired,
  scopes: PropTypes.arrayOf(PropTypes.string),
};

PermissionsGate.defaultProps = {
  scopes: [],
};
